import { createApp, provide, h } from 'vue'
import { DefaultApolloClient } from '@vue/apollo-composable'
import { ApolloLink, concat, split, ApolloClient, createHttpLink, HttpLink, InMemoryCache } from '@apollo/client/core'
import { getMainDefinition } from "@apollo/client/utilities"
import App from './App.vue'
import offCanvasAppComponent from './components/offCanvasAppComponent.vue'

const httpLink = new HttpLink({ 
  // uri: 'https://www.scattergoodfoundation.org/graphql',  
  uri: 'https://www.scattergoodfoundation.org/iu798djflap0oewfjjlsssis53ess',  
  // uri: 'https://scattergooddev.wpengine.com/graphql',
  // uri: 'https://scattergoostg.wpengine.com/graphql',
  // uri: 'https://sg.jb.local/graphql',
  // uri: process.env.VUE_APP_API_TARGET 

});
const cache = new InMemoryCache()

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
const token = localStorage.getItem('token');
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : "",
    },
  });
  return forward(operation);
});
export const apolloClient = new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache: cache,
});

// const apolloClient = new ApolloClient({
//   cache,
//   // uri: 'https://scattergooddev.wpengine.com/graphql',
//   // uri: 'https://scattergoostg.wpengine.com/graphql',
//   uri: 'https://sg.jb.local/graphql',
// })

const app = createApp({
  setup () {
    provide(DefaultApolloClient, apolloClient)
  },

  render: () => h(App),
})


app.mount('#app');





const offCanvasApp = createApp({
  setup () {
    provide(DefaultApolloClient, apolloClient)
  },

  render: () => h(offCanvasAppComponent),
})


offCanvasApp.mount('#offcanvas-vue');



  